<template>
  <!-- 内页，点击项目后的详情页面 -->
  <div class="inner-page">
    <div class="container">
      <!-- 背景星星 -->
      <div class="star_wrap">
        <img src="../../public/inner/bg/0706-不闪星星-07.png" alt="" />
      </div>
      <!-- 背景移动的云 -->
      <div class="cloud_wrap">
        <img
          class="cloud_floor"
          src="../../public/inner/bg/0706-底层云-07.png"
          alt=""
        />
        <img
          class="cloud_floor_ag"
          src="../../public/inner/bg/0706-底层云-07.png"
          alt=""
        />
        <img
          class="cloud_middle"
          src="../../public/inner/bg/0706-中层云-01.png"
          alt=""
        />
        <img
          class="cloud_middle_ag"
          src="../../public/inner/bg/0706-中层云-01.png"
          alt=""
        />
      </div>
    </div>
    <!-- 图片展示区域 -->
    <div id="main">
      <!-- 横版内容区域,用vue获取数据,填充 -->
      <div class="horizontal">
        <!-- video -->
        <div
          class="content_video"
          v-for="(video_item, index) in viedoList_horz"
          :key="'viedoList_horz' + index"
          @click="play_video($event)"
        >
          <video
            :src="video_item.src"
            :poster="video_item.poster"
            controls
          ></video>
          <div class="text">
            <h1>{{ video_item.title }}</h1>
            <p>{{ video_item.content }}</p>
            <p>制作于：{{ video_item.time }}</p>
          </div>
          <div class="cover1"></div>
          <div class="cover2"></div>
        </div>

        <!-- image -->
        <div
          class="content"
          v-for="(item, index) in imgList_horz"
          :key="'horz' + index"
        >
          <img v-lazy="item.src" class="lazyload" alt="" />
          <div class="text">
            <h1>{{ item.title }}</h1>
            <p>{{ item.content }}</p>
            <p>制作于：{{ item.time }}</p>
          </div>
        </div>

        <!-- PR-Video -->
        <div
          class="prVideo"
          v-for="(prItem, prIndex) in prList"
          :key="'pr' + prIndex"
        >
          <video controls :src="prItem[0].srcv"></video>
          <div class="prText">
            <h1 style="white-space: normal; font-size: 1em; margin: 2em 0">
              {{ prItem[0].title }}
            </h1>
          </div>
        </div>
      </div>
      <!-- 竖版内容区域,用vue获取数据,填充 -->
      <div class="vertical">
        <!-- video -->
        <div
          class="content_video"
          v-for="(video_item, index) in videoList_vert"
          :key="'viedoList_horz' + index"
          @click="play_video($event)"
        >
          <video
            :src="video_item.src"
            :poster="video_item.poster"
            controls
          ></video>
          <div class="text">
            <h1>{{ video_item.title }}</h1>
            <p>{{ video_item.content }}</p>
            <p>制作于：{{ video_item.time }}</p>
          </div>
          <div class="cover1"></div>
          <div class="cover2"></div>
        </div>

        <!-- images -->
        <div
          class="content"
          v-for="(item_v, index) in imgList_vert"
          :key="index"
        >
          <img class="lazyload" v-lazy="item_v.src" alt="" />
          <div class="text">
            <h1>{{ item_v.title }}</h1>
            <p>{{ item_v.content }}</p>
            <p>制作于：{{ item_v.time }}</p>
          </div>
        </div>

        <!-- PR-Images -->
        <div
          class="prImage"
          v-for="(prItem, prIndex) in prList"
          :key="'pr' + prIndex"
        >
          <img
            v-for="(prItemImage, prItemImageIndex) in prItem"
            :key="'image' + prItemImageIndex"
            :src="prItemImage.src"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 标题图片 -->
    <div class="inner_bg">
      <img
        class="page_h1"
        :src="change_content(this.$route.query.pageId)"
        alt=""
      />
    </div>

    <!-- 返回首页的按钮 -->
    <div class="back_index" @click="back">
      <svg
        style="fill: #fff"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 520.24 107.14"
      >
        <title>mark资源 3</title>
        <g id="图层_2" data-name="图层 2">
          <g id="图层_1-2" data-name="图层 1">
            <rect
              class="cls-1"
              x="74.67"
              y="38.05"
              width="252"
              height="31.03"
            />
            <polygon
              class="cls-1"
              points="0 53.57 74.67 0 74.67 53.57 0 53.57"
            />
            <polyline class="cls-1" points="74.67 53.57 0 53.57 74.67 107.14" />
            <text
              style="font-size: 55px"
              class="cls-2"
              transform="translate(359.48 77.23)"
            >
              BACK
            </text>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList_horz: [],
      imgList_vert: [],
      viedoList_horz: [],
      videoList_vert: [],
      prList: []
    };
  },
  methods: {
    // 获取标题图片
    change_content(i) {
      return require(`../../public/inner/bg/inner_${i}_bg.png`);
    },

    // 播放视频
    play_video(e) {
      let text = e.currentTarget.querySelector(".text");
      let cover1 = e.currentTarget.querySelector(".cover1");
      let cover2 = e.currentTarget.querySelector(".cover2");
      text.style.opacity = 0;
      cover1.style.height = 0;
      cover2.style.height = 0;
      e.currentTarget.style.cursor = "default";
    },
    // 返回首页
    back() {
      this.$router.push("/");
      window.scrollTo(0, 0);
    },
    // 获取本地data.json的数据
    getData(id) {
      fetch("./data/data.json")
        .then(res => {
          return res.json();
        })
        .then(data => {
          // PR 数据
          if (id == 6) {
            this.prList = data[0][id - 1];
            console.log(this.prList);
            return;
          }
          // 横版图片
          this.imgList_horz = data[0][id - 1];
          // 竖版图片
          this.imgList_vert = data[1][id - 1];
          // 视频文件
          if (id == 1) {
            this.viedoList_horz[0] = data[2][id - 1][0];
            this.viedoList_horz[1] = data[2][id - 1][1];
            this.viedoList_horz[2] = data[2][id - 1][2];

            this.videoList_vert[0] = data[2][id - 1][3];
            this.videoList_vert[1] = data[2][id - 1][4];
          } else {
            this.viedoList_horz = data[2][id - 1];
          }
        })
        .catch(e => {
          console.log(e.message);
        });
    }
  },
  created() {
    // 获取用户点击的页面id
    this.getData(this.$route.query.pageId);
  }
};
</script>

<style scoped>
.inner-page {
  width: 100%;
  height: 100vh;
}

.container {
  width: 80%;
  height: 100vh;
  background-color: #161f2b;
  position: fixed;

  left: 10%;

  min-width: 900px;

  pointer-events: none;
}
.star_wrap {
  position: relative;
}
.star_wrap img {
  width: 100%;
}
.cloud_wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
}

.cloud_middle,
.cloud_floor,
.cloud_floor_ag,
.cloud_middle_ag {
  position: absolute;
  top: 0%;
  width: 100%;
  -webkit-animation: cloud_move 80s linear infinite alternate;
  animation: cloud_move 80s linear infinite alternate;
}
.cloud_floor {
  top: 60%;
  right: -19%;
  -webkit-animation: cloud_move 120s linear infinite alternate;
  animation: cloud_move 120s linear infinite alternate;
}
.cloud_floor_ag {
  top: 20%;
  -webkit-animation: cloud_move 120s linear infinite alternate;
  animation: cloud_move 120s linear infinite alternate;
}
.cloud_middle_ag {
  top: 40%;
}

@-webkit-keyframes cloud_move {
  from {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  to {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}

@keyframes cloud_move {
  from {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  to {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}

#main {
  height: 100vh;
  display: -webkit-box;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
  align-items: center;

  position: absolute;
  width: 80%;

  left: 10%;
  top: 26rem;
  z-index: 1;
}

#main .horizontal,
#main .vertical {
  width: 100%;
  height: 100%;
  text-align: center;
}

#main .horizontal {
  -webkit-box-flex: 1.5;
  flex: 1.5;
  padding-left: 5%;
}
#main .vertical {
  -webkit-box-flex: 1;
  flex: 1;
  padding-right: 5%;
}
#main .vertical .content_video {
  text-align: center;
  overflow: hidden;
  width: 100%;
  margin-bottom: 15%;
  position: relative;
}

.horizontal img,
.vertical img {
  width: 100%;
  -webkit-transition: 0.3s linear;
  transition: 0.3s linear;
}
.prVideo {
  width: 90%;
  margin-bottom: 52%;
}
.prVideo video {
  width: 100%;
  cursor: pointer;
  outline: none;
}
.prImage {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 30%;
}
.prImage img {
  width: 100%;
  outline: none;
}

.horizontal .content,
.vertical .content {
  text-align: center;
  overflow: hidden;
  width: 100%;
  margin-bottom: 15%;
  position: relative;
}
.horizontal .content,
.horizontal .content_video {
  margin-bottom: 15%;
  width: 90%;
}
.horizontal .content {
  padding-right: 0;
}

.content:hover img {
  -webkit-transform: scale(1.1) rotate(3deg);
  transform: scale(1.1) rotate(3deg);
}
.content_video video {
  width: 100%;
  cursor: pointer;
  outline: none;
}
.content_video {
  position: relative;
  cursor: pointer;
}
.content_video .cover1,
.content_video .cover2 {
  position: absolute;
  width: 100%;
  background: #000;
  opacity: 0;
  left: 0;
  height: 0;
  z-index: 999;
  -webkit-transition: 0.3s linear;
  transition: 0.3s linear;
}
.cover1 {
  top: 0;
}
.cover2 {
  bottom: 0;
}
.content_video:hover .cover1 {
  height: 50%;
  opacity: 0.5;
}
.content_video:hover .cover2 {
  height: 50%;
  opacity: 0.5;
}

.content::after,
.content::before {
  content: "";
  position: absolute;
  width: 100%;
  background: #000;
  opacity: 0;
  left: 0;
  height: 0;
  z-index: 999;
  -webkit-transition: 0.3s linear;
  transition: 0.3s linear;
}
.content::before {
  bottom: 0;
}

.content:hover::before,
.content:hover::after {
  opacity: 0.7;
  height: 50%;
}
.content:hover::after {
  left: 0;
  bottom: 0;
}

.content:hover::before {
  left: 0;
  top: 0;
}

.content_video .text {
  pointer-events: none;
}
.text {
  position: absolute;
  text-align: center;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 9999;
  opacity: 0;
  -webkit-transition: 0.3s linear;
  transition: 0.3s linear;
  white-space: normal;
}

.text {
  width: 100%;
}

.text h1 {
  font-size: 3vw;
  white-space: nowrap;
  margin: 0;
}
.text p {
  font-size: 1rem;
  letter-spacing: 2px;
  text-align: center;
  line-height: 1.7rem;
}

.content:hover .text,
.content_video:hover .text {
  opacity: 1;
}

.back_index {
  position: fixed;
  top: 10%;
  right: 1%;
  cursor: pointer;
  z-index: 9;
}
svg {
  width: 8rem;
}

.inner_bg {
  position: absolute;
  -webkit-transition: opacity 0.5s linear;
  transition: opacity 0.5s linear;
  width: 80%;
  left: 14%;
  height: 12.3rem;
  top: 10rem;
}
.page_h1 {
  height: 100%;
}

.h1_active {
  opacity: 1;
}

#main .content {
  height: auto;
}
</style>
